<form [formGroup]="formGroup()" class="title-name-form-row">
  @if (!showTitle()) {
    <div class="col-auto my-2">
      <app-validated-dropdown
        [label]="'general.nameTitle'"
        inputFormControlName="title"
        [inputFormControl]="formGroup().controls.title"
        [disabled]="disabled()"
        [loading]="!genericDataStore.allLoaded() || genericDataStore.nameTitlesEntities().length === 0"
        [optionsStamp]="genericDataStore.nameTitlesEntities().length"
      >
        @for (nameTitle of genericDataStore.nameTitlesEntities(); track nameTitle.code) {
          <option [value]="nameTitle.code">
            {{ nameTitle.localized | getLocalized }}
          </option>
        }
      </app-validated-dropdown>
    </div>
  }
  <app-name-form
    [formGroup]="formGroup().controls.name"
    [showTitle]="showTitle()"
    [titleFormControl]="formGroup().controls.title"
  />
</form>
